function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import 'es6-promise/auto';
import GoogleMapReact from 'google-map-react';
import { getAdditionalProps } from '../utils/propTypes';
import { CENTER_OF_THE_WORLD, COORDINATE_SHAPE, DEFAULT_ZOOM, DIMENSIONS_TYPE, ELEMENT_TYPES, LOCAL_MAP_OPTIONS, MAP_TYPE_LOCAL, MAP_TYPE_WORLD, MAP_TYPES, WORLD_MAP_OPTIONS } from './constants';

var InteractiveMap =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(InteractiveMap, _PureComponent);

  function InteractiveMap() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, InteractiveMap);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(InteractiveMap)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_getMapOptions", function (mapType, options) {
      return _objectSpread({}, mapType === MAP_TYPE_LOCAL ? LOCAL_MAP_OPTIONS : WORLD_MAP_OPTIONS, options);
    });

    return _this;
  }

  _createClass(InteractiveMap, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          center = _this$props.center,
          children = _this$props.children,
          defaultCenter = _this$props.defaultCenter,
          defaultZoom = _this$props.defaultZoom,
          googleMapsApiKey = _this$props.googleMapsApiKey,
          googleMapsClient = _this$props.googleMapsClient,
          height = _this$props.height,
          language = _this$props.language,
          mapType = _this$props.mapType,
          onChange = _this$props.onChange,
          onChildClick = _this$props.onChildClick,
          onClick = _this$props.onClick,
          onTilesLoaded = _this$props.onTilesLoaded,
          options = _this$props.options,
          region = _this$props.region,
          resetBoundsOnResize = _this$props.resetBoundsOnResize,
          width = _this$props.width,
          zoom = _this$props.zoom; // Make it so that the `key` and `client` properties will not
      // be on the bootstrapURLKeys object if the value is falsy

      var bootStrapURLKeysKey = googleMapsApiKey ? {
        key: googleMapsApiKey
      } : {};
      var bootStrapURLKeysClient = googleMapsClient ? {
        client: googleMapsClient
      } : {};
      var extraAttrs = getAdditionalProps(this);
      return React.createElement("div", {
        className: "interactive-map",
        style: {
          width: width,
          height: height
        }
      }, React.createElement(GoogleMapReact, _extends({
        bootstrapURLKeys: _objectSpread({}, bootStrapURLKeysKey, bootStrapURLKeysClient, {
          language: language,
          region: region
        }),
        defaultCenter: defaultCenter,
        center: center,
        defaultZoom: defaultZoom,
        zoom: zoom,
        onChange: onChange,
        onChildClick: onChildClick,
        onClick: onClick,
        onZoomAnimationEnd: this._handleZoomAnimationEnd,
        onZoomAnimationStart: this._handleZoomAnimationStart,
        resetBoundsOnResize: resetBoundsOnResize,
        options: this._getMapOptions(mapType, options),
        onTilesLoaded: onTilesLoaded
      }, extraAttrs), children));
    }
  }]);

  return InteractiveMap;
}(PureComponent);

_defineProperty(InteractiveMap, "propTypes", {
  /**
   * API Key for requests to Google Maps API. Can be used instead of a client param.
   */
  googleMapsApiKey: PropTypes.string,

  /**
   * Client param to pass to Google Maps API. Can be used instead of an API key.
   */
  googleMapsClient: PropTypes.string,

  /**
  * Which of the defined map styles to use.
  */
  mapType: PropTypes.oneOf(MAP_TYPES),

  /**
  * Height for the map container, with units
  */
  height: DIMENSIONS_TYPE,

  /**
  * Width for the map container, with units
  */
  width: DIMENSIONS_TYPE,

  /**
   * Two-letter language code
   */
  language: PropTypes.string,

  /**
   * Two-letter region code
   */
  region: PropTypes.string,

  /**
  * Default map zoom level - changing this prop throws a warning
  */
  defaultZoom: PropTypes.number,

  /**
  * Zoom level
  */
  zoom: PropTypes.number,

  /**
  * Function that is called when the bounds change
  * ({ center, zoom, bounds, marginBounds })
  */
  onChange: PropTypes.func,

  /**
  * Function that is called when the map is clicked
  * ({ x, y, lat, lng, event })
  */
  onClick: PropTypes.func,

  /**
  * Function that is called when a child of the map is clicked
  */
  onChildClick: PropTypes.func,

  /**
  * Function that is called when the visible tiles have finished loading
  */
  onTilesLoaded: PropTypes.func,

  /**
  * Function that is called when zoom animation starts
  */
  onZoomAnimationStart: PropTypes.func,

  /**
  * Function that is called at the end of the zoom animation
  */
  onZoomAnimationEnd: PropTypes.func,

  /**
  * Options to override default options. To be used sparingly. */
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.object,

  /**
  * One or more children to display on the map that will be positioned
  * according to their lat and lng props.
  */
  children: ELEMENT_TYPES,

  /**
  * The default center point of the portion of the map to be shown. Should not change.
  */
  defaultCenter: COORDINATE_SHAPE,

  /**
  * The center point of the portion of the map to be shown.
  */
  center: COORDINATE_SHAPE,

  /**
  * Whether the bounds for the map should be reset on window resize
  */
  resetBoundsOnResize: PropTypes.bool
});

_defineProperty(InteractiveMap, "defaultProps", {
  defaultCenter: CENTER_OF_THE_WORLD,
  defaultZoom: DEFAULT_ZOOM,
  language: 'en',
  mapType: MAP_TYPE_WORLD,
  region: 'us'
});

export { InteractiveMap as default };